import React from 'react'
import PropTypes from 'prop-types'

import { List } from 'immutable'

// styles
import style from '@aytm/app/stats/page/sidebar/reports/styles/ReportPopup.module.scss'

const APPLIED_FILTERS_EMPTY = 'None'

// Read-only "Applied filters, customizations" rows for the report-popup description
// column. Each filter renders its title and, when present, its HTML value. Rendered
// as the body of a ReportPopupSection, which is offered on every report - a report
// nobody has filtered reads its own emptiness rather than losing the section.
const ReportPopupAppliedFilters = ({ filters }) =>
  !filters || 0 === filters.size ? (
    <div className={style['description-content-section-body-content-row']}>{APPLIED_FILTERS_EMPTY}</div>
  ) : (
    <>
      {filters
        .map((filter, index) =>
          filter.get('value') ? (
            <div key={`filter-${index}`} className={style['description-content-section-body-content-row']}>
              <b>{filter.get('title')}:</b>
              <br />
              <div dangerouslySetInnerHTML={{ __html: filter.get('value') }} />
            </div>
          ) : (
            <div key={`filter-${index}`} className={style['description-content-section-body-content-row']}>
              <b>{filter.get('title')}</b>
            </div>
          )
        )
        .toArray()}
    </>
  )

ReportPopupAppliedFilters.propTypes = {
  filters: PropTypes.instanceOf(List)
}

ReportPopupAppliedFilters.displayName = 'ReportPopupAppliedFilters'

export default ReportPopupAppliedFilters
